<div class="header">
  <h3>บันทึกกิจกรรม</h3>
</div>
<div class="box-filter position-relative z-2">
  <app-filter-header [loading]="loading"
                     (search)="searchButtonClicked()"
                     (clear)="clearData()"></app-filter-header>
  <div class="row row-eq-height">

    <div class="col-md-4">
      <div class="dropdown-label-group">
        <p-dropdown
          class="dv-dropdown"
          selectId="username"
          [options]="usernames"
          [(ngModel)]="searchUsername"
          [autoDisplayFirst]="false"
          placeholder="ชื่อผู้ใช้"
          [style]="{'z-index': 4}"
        >
        </p-dropdown>
        <label for="username">ชื่อผู้ใช้</label>
      </div>
    </div>

    <div class="col-md-4">
      <div class="dropdown-label-group">
        <p-dropdown
          class="dv-dropdown"
          selectId="group"
          [options]="roles"
          [(ngModel)]="searchRole"
          [autoDisplayFirst]="false"
          placeholder="สิทธิ์การเข้าถึง"
        >
        </p-dropdown>
        <label for="group">สิทธิ์การเข้าถึง</label>
      </div>
    </div>

  </div>
  <div class="row row-eq-height m-t-10">

    <div class="col-md-4">
      <div class="dropdown-label-group">
        <p-dropdown
          class="dv-dropdown"
          selectedId="action"
          [options]="actions"
          [(ngModel)]="searchAction"
          [autoDisplayFirst]="false"
          placeholder="รายละเอียดการใช้งาน"
        >
        </p-dropdown>
        <label for="action">รายละเอียดการใช้งาน</label>
      </div>
    </div>

    <div class="col-md-4">
      <div class="dropdown"
           #dd="ngbDropdown"
           ngbDropdown
           autoClose="outside">
        <div class="form-label-group">
          <input #ddi
                 class="form-control"
                 type="text"
                 id="calendarDropdown"
                 [value]="dateRange"
                 ngbDropdownToggle
                 placeholder="วันที่"
                 readonly>
          <label for="calendarDropdown">วันเวลา</label>
          <div class="calendar-trigger"
               (click)="$event.stopPropagation(); sentDate(); dd.toggle()">
            <span class="far fa-calendar"></span>
          </div>
        </div>
        <div class="dropdown-menu"
             ngbDropdownMenu
             aria-labelledby="calendarDropdown">
          <div class="row">
            <div class="col"
                 style="padding-left: 30px">ตั้งแต่
            </div>
            <div class="col"
                 style="padding-left: 30px">ถึง
            </div>
          </div>
          <div (click)="$event.stopPropagation()">
            <p-calendar [(ngModel)]="startDate"
                        [defaultDate]="startDate"
                        dateFormat="dd/mm/yy"
                        [maxDate]="maxDate"
                        readonlyInput="true"
                        [showIcon]="true"
                        [monthNavigator]="true"
                        [yearNavigator]="true"
                        [yearRange]="yearRange"
                        (onSelect)="setMinDate"
                        [inline]="true"
                        [locale]="calendarLocale"></p-calendar>
            <p-calendar [(ngModel)]="endDate"
                        [defaultDate]="startDate"
                        dateFormat="dd/mm/yy"
                        [minDate]="minDate"
                        readonlyInput="true"
                        [showIcon]="true"
                        [monthNavigator]="true"
                        [yearNavigator]="true"
                        [yearRange]="yearRange"
                        (onSelect)="setMaxDate(); dd.close()"
                        [inline]="true"
                        [locale]="calendarLocale">
            </p-calendar>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-4">
      <div class="form-label-group">
        <input class="form-control"
               type="text"
               id="detail"
               [(ngModel)]="searchDetail"
               placeholder="เลขที่เอกสาร หรือ รายละเอียด">
        <label for="searchText">เลขที่เอกสาร หรือ รายละเอียด</label>
      </div>
    </div>


  </div>
</div>

<div class="box-parent position-relative z-1">
  <app-custom-pagination
    [(currentPage)]="currentPage"
    [(itemsPerPage)]="itemsPerPage"
    [totalItems]="totalItems"
    [maxSize]="5"
    (pageChange)="pageChanged()"
    (optionChange)="searchButtonClicked()"
    *ngIf="loading === false && totalItems !== 0"
  >
    <button type="button"
            class="btn btn-dv btn-wide"
            [disabled]="loading_excel_report"
            (click)="DownloadReport()">
      <i *ngIf="loading_excel_report"
         class="fa fa-spinner fa-spin m-r-5"></i>
      ดาวน์โหลดรายงาน
    </button>
  </app-custom-pagination>

  <div class="row m-t-20"
       *ngIf="totalItems === 0 && loading === false">
    <div class="col-12 text-center">
      <h5>ไม่พบข้อมูล</h5>
    </div>
  </div>

  <div class="m-t-20 text-center">
    <p-table #tt
             tableStyleClass="table"
             *ngIf="totalItems !== 0"
             [loading]="loading"
             [columns]="tableCol"
             [value]="tableData"
             [customSort]="true"
             (onSort)="sort($event)"
             [autoLayout]="true">
      <ng-template pTemplate="header"
                   let-columns>
        <tr>
          <th scope="col">ลำดับ</th>
          <th id="th-not-order"
              *ngFor="let col of columns"
              [pSortableColumn]="col.field"
              (click)="pageChanged()">
            {{ col.header }}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body"
                   let-data
                   let-index="rowIndex">
        <tr>
          <td>{{ index + 1 + ((currentPage - 1) * itemsPerPage) }}</td>
          <td>{{ data.created_at | date:"dd/MM/yyyy HH:mm" }}</td>
          <td>{{ data.role_name }}</td>
          <td>{{ data.username }}</td>
          <td class="text-left"
              *ngIf="data.target">{{ data.action_display }} - {{ data.target }}
          </td>
          <td class="text-left"
              *ngIf="!data.target">{{ data.action_display }}
          </td>
          <td>{{ data.address_display }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>



// WEBPACK FOOTER //
// /opt/app/src/app/features/operation-log/operation-log.component.html